import TextLayout from "~/components/common/TextLayout";
import htmlContent from "~/data/legal-document/shipping.html?raw";

export default function ShippingPolicyPage() {
  return <TextLayout title="Shipping Policy" htmlContent={htmlContent} />;
}
